<script setup lang="ts">
import StatisticsPage from '../features/stats/StatisticsPage.vue';
</script>

<template>
  <StatisticsPage />
</template>
